import { useState, useEffect } from 'react'
import { useStoreActions } from 'easy-peasy'

export default function Container ({ children }) {
  const [currentTab, setCurrentTab] = useState('promos')

  const customPromoBannerAd = {
    link: '/supercard/buy',
    bg: '/images/supercard-bg-banner.png',
    text: {
      center: true,
      title: 'Your Supercard made more SUPER!',
      description: 'Supercard Members enjoy these benefits from Shakey’s and Peri-Peri Charcoal Chicken and Sauce Bar'
    },
    btnText: 'Know More'
  }
  const actions = useStoreActions(a => ({
    getPromos: a.getPromos
  }))

  useEffect(() => {
    actions.getPromos()
  }, [])

  return children({
    currentTab,
    setCurrentTab,
    customPromoBannerAd
  })
}
